import type { LinkMap } from "@saflib/links";

const subdomain = "admin";

export const adminLinks: LinkMap = {
  home: {
    subdomain,
    path: "/",
  },
  testUtils: {
    subdomain,
    path: "/test-utils",
  },
  mockEmailsLast: {
    subdomain,
    path: "/mock-emails/last",
    // `userEmail` is accepted for RegistrationPageFixture.completeEmailVerification;
    // LastMockEmailPage prefers session email and also reads `user_email` if present.
    params: ["subdomain", "userEmail"],
  },
  cronJobs: {
    subdomain,
    path: "/cron",
  },
  emails: {
    subdomain,
    path: "/emails",
    params: ["userEmail"],
  },
  logs: {
    subdomain,
    path: "/logs",
  },
  metrics: {
    subdomain,
    path: "/metrics",
  },
  events: {
    subdomain,
    path: "/events",
  },
  errors: {
    subdomain,
    path: "/errors",
  },
  // BEGIN WORKFLOW AREA page-links FOR vue/add-view
  dashboard: {
    subdomain,
    path: "/",
  },
  transactions: {
    subdomain,
    path: "/transactions",
  },
  transactionDetail: {
    subdomain,
    path: "/transactions/:id",
    params: ["id"],
  },
  repairs: {
    subdomain,
    path: "/repairs",
  },
  repairDetail: {
    subdomain,
    path: "/repairs/:id",
    params: ["id"],
  },
  // END WORKFLOW AREA
} as const;
